import React from 'react';
import { Link } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import { Alert, Form, Button } from 'react-bootstrap';
import { Input, Checkbox, FormActions } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';
import Localizations from '../localization';
import TimeZonePicker from '../timeZones/TimeZonePicker';

const SettingsForm = ({ error, handleSubmit, pristine, submitting, submitSucceeded, isReadonly, initialValues, defaultTimeZone, t }) => {
	let id = initialValues ? initialValues.id : 0;

	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			<Field name='name' component={Input} disabled={isReadonly} horizontal required type='text' label={t('Franchisee_Name')} validate={validators.required} />
			{id > 0 && <Localizations entityId={id} rootName={'franchisees'} propertyName={'Name'} label={t('Franchisee_Name')} resourceName={`Franchisee.${id}.Name`} isHtml={false} isReadonly={isReadonly} />}
			<Field name='contactPerson' component={Input} disabled={isReadonly} horizontal type='text' label={t('Franchisee_ContactPerson')} />
			<Field name='address' component={Input} disabled={isReadonly} horizontal required type='text' label={t('Franchisee_Address')} validate={[validators.required]} />
			<Field name='companyNumber' component={Input} disabled={isReadonly} horizontal type='text' label={t('Franchisee_CompanyNumber')} />
			<Field name='taxNumber' component={Input} disabled={isReadonly} horizontal type='text' label={t('Franchisee_TaxNumber')} />
			<Field name='taxRate' component={Input} disabled={isReadonly} horizontal type='text' label={t('Franchisee_TaxRate')} validate={validators.number} />
			<Field name='phoneNumber' component={Input} disabled={isReadonly} horizontal type='text' label={t('Franchisee_PhoneNumber')} />
			<Field name='mobilePhone' component={Input} disabled={isReadonly} horizontal type='text' label={t('Franchisee_MobilePhone')} />
			<TimeZonePicker name='timeZone' disabled={isReadonly} horizontal label={t('Franchisee_TimeZone')} emptyValue={defaultTimeZone} />
			<Field name='description' component={Input} disabled={isReadonly} horizontal componentClass='textarea' label={t('Franchisee_Description')} />
			<Field name='isOnline' component={Checkbox} disabled={isReadonly} horizontal label={t('Franchisee_IsOnline')} normalize={(v) => !!v} />
			<FormActions horizontal>
				<Link to='/franchisees' className='btn btn-default'>{t('Common_BackToList')}</Link>
				<Button type='submit' disabled={isReadonly || pristine || submitting} bsStyle='primary'>{t('Common_Save')}</Button>
			</FormActions>
		</Form >
	);
};

export default reduxForm({ form: 'franchisee', enableReinitialize: true })(withTranslation()(SettingsForm));
